import type { StatusVariant } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import type { AggregatedStatus } from 'modules/integrations/lib/syncableStatus'

export type SyncStatusMode = 'api' | 'file'

const statusTagColorMap: Record<AggregatedStatus, StatusVariant> = {
  failed: 'critical',
  outdated: 'warning',
  partiallySynced: 'warning',
  pending: 'neutral',
  synced: 'positive',
  syncing: 'info',
}

export function getSyncStatusTagColor(status: AggregatedStatus): StatusVariant {
  return statusTagColorMap[status]
}

export function getSyncStatusTagLabel(status: AggregatedStatus, mode: SyncStatusMode): string {
  if (mode === 'file') {
    switch (status) {
      case 'failed':
        return i18n.t('integrations.columns.export_status.failed')
      case 'outdated':
        return i18n.t('integrations.columns.export_status.outdated')
      case 'partiallySynced':
        return i18n.t('integrations.columns.export_status.partially_synced')
      case 'pending':
        return i18n.t('integrations.columns.export_status.pending')
      case 'synced':
        return i18n.t('integrations.columns.export_status.synced')
      case 'syncing':
        return i18n.t('integrations.columns.export_status.syncing')
    }
  }

  switch (status) {
    case 'failed':
      return i18n.t('integrations.columns.sync_status.failed')
    case 'outdated':
      return i18n.t('integrations.columns.sync_status.outdated')
    case 'partiallySynced':
      return i18n.t('integrations.columns.sync_status.partially_synced')
    case 'pending':
      return i18n.t('integrations.columns.sync_status.pending')
    case 'synced':
      return i18n.t('integrations.columns.sync_status.synced')
    case 'syncing':
      return i18n.t('integrations.columns.sync_status.syncing')
  }
}
